export enum SubscrStatusEnum {
    UnKnown = 0,
    Future = 1,
    InTrial = 2,
    Active = 3,
    NonRenewing = 4,
    Paused = 5,
    Cancelled = 6,
}

export enum PeriodUnitEnum {
    UnKnown = 0,
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}
